
import { RevButton } from '@ds/components/Button'
import { RevContainer } from '@ds/components/Container'
import { RevIllustration } from '@ds/components/Illustration'
import { RevStickyBar } from '@ds/components/StickyBar'

import Model from '../Model'
import PriceWrapper from '../PriceWrapper'

import translations from './AddToCart.translations'

const POSITION_Y_STICKYBAR_DISPLAY = -100

export default {
  components: {
    RevButton,
    RevContainer,
    RevIllustration,
    Model,
    PriceWrapper,
    RevStickyBar,
  },

  props: {
    isVatIncluded: {
      type: Boolean,
      required: false,
      default: false,
    },
    originalPrice: {
      type: Object,
      default: () => ({}),
    },
    price: {
      type: Object,
      required: true,
    },
    priceColor: {
      type: String,
      required: true,
    },
    priceLabel: {
      type: String,
      required: true,
    },
    priceEmphasis: {
      type: String,
      required: true,
    },
    productImage: {
      type: Object,
      default: () => ({}),
    },
    subTitle: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      showBottomBar: false,
    }
  },

  computed: {
    translations: () => translations,

    addToCartButtonLabel() {
      return this.$t(this.translations.addToCart)
    },
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    async addToCart() {
      this.$emit('cart')
    },
    handleScroll() {
      window.requestAnimationFrame(() => {
        const { desktopAddToCartCta } = this.$refs
        const desktopAddToCartCtaBottomScroll =
          desktopAddToCartCta.getBoundingClientRect().bottom

        // Show the sticky bar if the user scrolls past the add to cart button
        if (desktopAddToCartCtaBottomScroll <= POSITION_Y_STICKYBAR_DISPLAY) {
          this.showBottomBar = true
        }

        // Hide the sticky bar if the add to cart button is visible
        if (desktopAddToCartCtaBottomScroll > 0) {
          this.showBottomBar = false
        }
      })
    },
  },
}
